import { render, staticRenderFns } from "./CustomerBox.vue?vue&type=template&id=a9b5620e&scoped=true&"
import script from "./CustomerBox.vue?vue&type=script&lang=js&"
export * from "./CustomerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5620e",
  null
  
)

export default component.exports